import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {DateAdapter} from '@angular/material/core';
import {ErrorStateMatcher} from '@angular/material/core';
import {FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ProductLotService} from 'src/app/services/product-lot.service';
import {Lot} from 'src/app/models/lot';
import {ProductPriceDialogComponent} from '../product-price-dialog/product-price-dialog.component';
import {ProductPriceService} from 'src/app/services/product-price.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {ProductCatPriceService} from 'src/app/services/product-cat-price.service';
import {ProductCatPriceDialogComponent} from '../product-cat-price-dialog/product-cat-price-dialog.component';
import {CategoryPrice} from 'src/app/models/category-price';
import {AlertComponent} from 'src/app/shared/dialogs/alert/alert.component';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-product-lot-dialog',
  templateUrl: './product-lot-dialog.component.html',
  styleUrls: [ './product-lot-dialog.component.scss' ]
})
export class ProductLotDialogComponent implements OnInit {

  @ViewChild(MatSort, {static: false}) sort: MatSort;

  public matcher = new FormErrorStateMatcher();

  public lotForm: FormGroup;
  public displayedLotPricesColumns: string[] = [ 'icon', 'category', 'value', 'defaulting', 'edit', 'delete' ];

  constructor (
    private dialog: MatDialog,
    public _productLotService: ProductLotService,
    public _productPriceService: ProductPriceService,
    public _productCatPriceService: ProductCatPriceService,
    private _adapter: DateAdapter<any>,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit () {
    this._adapter.setLocale('pt');
    this._productLotService.currentProductLot = this.data.lot;
    this._productLotService.currentProduct = this.data.product;

    this._productLotService.setEdit()
    this.lotForm = this._productLotService.createForm(this._productLotService.currentProductLot);
  }

  ngAfterViewInit () {

    if (this._productLotService.currentProductLot.id) {
      this._productCatPriceService.loadCategoryPrices(this._productLotService.currentProduct.id, this._productLotService.currentProductLot.id)
    } else {
      this._productCatPriceService.productCatPricePartnerTrueDataSource = null;
      this._productCatPriceService.productCatPricePartnerFalseDataSource = null;
    }

  }

  async insert () {

    if (this.lotForm.valid) {
      const canInsert = await this._productLotService.canInsert(this.lotForm.value);

      if (!canInsert) {
             this.dialog.open(AlertComponent, {
               width: '450px',
               height: '300px',
               panelClass: 'custom-dialog-container',
               data: {title: "Alerta", message: "Já existe um lote com esta data \r\n para este produto."}
             });
        return;
       } else {
        this._productLotService.insert(this.lotForm.value)
          .then((e) => {
            this.lotForm.controls.id.setValue(e)
          })
      }
    }
  }

  update () {
    if (this.lotForm.valid) {
      this._productLotService.update(this.lotForm.value);

    }
  }

  deletePrice (element) {
console.log("delete price: " + element.id)
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + " <br><br>Excluir este grupo?"}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        console.log("element.id  ====>>> : " + element.id)
        this._productCatPriceService.deleteById(element.id)
    
      }
    })

  }

  //remove
  openPriceDialog (element) {
    let data: Lot = new Lot();

    if (element) {
      data = element;
    }

    this.dialog.open(ProductPriceDialogComponent, {
      width: '880px',
      height: '550px',
      panelClass: 'custom-dialog-container',
      data: {price: data, lot: this._productLotService.currentProductLot}
    });
  }


  openCatPriceDialog (isPartner, entity) {

    let data: CategoryPrice = new CategoryPrice();

    if (entity) {
      data = entity;
    }

    this.dialog.open(ProductCatPriceDialogComponent, {
      width: '860px',
      height: '520px',
      panelClass: 'custom-dialog-container',
      data: {
        'isPartner': isPartner,
        'categoryPrice': data,
        'lot': this._productLotService.currentProductLot,
        'product': this._productLotService.currentProduct
      }
    });
  }


}
